import { makeStyles } from '@material-ui/styles'

export const ButtonCancelStyles = makeStyles((theme) => ({
    btnCancel: {
        marginRight: theme.spacing(1),
        backgroundColor: theme.palette.colors.red,
        color: theme.palette.common.white,
        "&:hover": {
            backgroundColor: theme.palette.colors.red,
            color: theme.palette.common.white,
        },
        "&.Mui-disabled": {
            backgroundColor: theme.palette.colors.red,
            color: theme.palette.common.white,
            opacity: .5,
        },
    },
    btnCancelIconOnly: {
        backgroundColor: 'transparent !important',
        color: `${theme.palette.colors.red} !important`,
        minWidth: 0,
        padding: 6,
        '&:hover': {
            backgroundColor: 'rgba(255,0,0,0.08) !important',
            color: `${theme.palette.colors.red} !important`,
        },
        '& svg': {
            color: `${theme.palette.colors.red} !important`,
        }
    },
    btnCancelIconOnlyGray: {
        backgroundColor: 'transparent !important',
        color: '#757575 !important',
        minWidth: 0,
        padding: 6,
        '&:hover': {
            backgroundColor: 'rgba(117,117,117,0.08) !important',
            color: '#757575 !important',
        },
        '& svg': {
            color: '#757575 !important',
        }
    },
    btnIconOnlyRed: {
        backgroundColor: 'transparent !important',
        color: '#e53935 !important', 
        minWidth: 0,
        padding: 6,
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: 'rgba(229,57,53,0.08) !important',
            color: '#e53935 !important',
        },
        '& .MuiButton-label > svg': {
            color: '#e53935 !important',
}
},
}))